import { TPlaceholder, TPlaceholderParams } from './types';

export const PLACEHOLDERS_DICT = new Map<TPlaceholder, TPlaceholderParams>([
  [
    '[найдено малоэтажных]',
    {
      path: ['villageListSummary', 'house', 'count'],
      objectType: 'house',
      metricType: 'count',
    },
  ],
  [
    '[мин.цена малоэтажного]',
    {
      path: ['villageListSummary', 'house', 'minPrice'],
      metricType: 'price',
    },
  ],
  [
    '[сред.цена малоэтажного]',
    {
      path: ['villageListSummary', 'house', 'avgPrice'],
      metricType: 'price',
    },
  ],
  [
    '[макс.цена малоэтажного]',
    {
      path: ['villageListSummary', 'house', 'maxPrice'],
      metricType: 'price',
    },
  ],
  [
    '[мин.площадь малоэтажного]',
    {
      path: ['villageListSummary', 'house', 'minArea'],
      objectType: 'house',
      metricType: 'area',
    },
  ],
  [
    '[сред.площадь малоэтажного]',
    {
      path: ['villageListSummary', 'house', 'avgArea'],
      objectType: 'house',
      metricType: 'area',
    },
  ],
  [
    '[макс.площадь малоэтажного]',
    {
      path: ['villageListSummary', 'house', 'maxArea'],
      objectType: 'house',
      metricType: 'area',
    },
  ],
  [
    '[цена_за_м2 малоэтажного]',
    {
      path: ['villageListSummary', 'house', 'avgPricePerSqm'],
      metricType: 'price',
    },
  ],
  [
    '[найдено таунхаусов]',
    {
      path: ['villageListSummary', 'townhouse', 'count'],
      objectType: 'townhouse',
      metricType: 'count',
    },
  ],
  [
    '[мин.цена таунхауса]',
    {
      path: ['villageListSummary', 'townhouse', 'minPrice'],
      metricType: 'price',
    },
  ],
  [
    '[сред.цена таунхауса]',
    {
      path: ['villageListSummary', 'townhouse', 'avgPrice'],
      metricType: 'price',
    },
  ],
  [
    '[макс.цена таунхауса]',
    {
      path: ['villageListSummary', 'townhouse', 'maxPrice'],
      metricType: 'price',
    },
  ],
  [
    '[мин.площадь таунхауса]',
    {
      path: ['villageListSummary', 'townhouse', 'minArea'],
      objectType: 'townhouse',
      metricType: 'area',
    },
  ],
  [
    '[сред.площадь таунхауса]',
    {
      path: ['villageListSummary', 'townhouse', 'avgArea'],
      objectType: 'townhouse',
      metricType: 'area',
    },
  ],
  [
    '[макс.площадь таунхауса]',
    {
      path: ['villageListSummary', 'townhouse', 'maxArea'],
      objectType: 'townhouse',
      metricType: 'area',
    },
  ],
  [
    '[цена_за_м2 таунхауса]',
    {
      path: ['villageListSummary', 'townhouse', 'avgPricePerSqm'],
      metricType: 'price',
    },
  ],
  [
    '[найдено коттеджей]',
    {
      path: ['villageListSummary', 'cottage', 'count'],
      objectType: 'cottage',
      metricType: 'count',
    },
  ],
  [
    '[мин.цена коттеджа]',
    {
      path: ['villageListSummary', 'cottage', 'minPrice'],
      metricType: 'price',
    },
  ],
  [
    '[сред.цена коттеджа]',
    {
      path: ['villageListSummary', 'cottage', 'avgPrice'],
      metricType: 'price',
    },
  ],
  [
    '[макс.цена коттеджа]',
    {
      path: ['villageListSummary', 'cottage', 'maxPrice'],
      metricType: 'price',
    },
  ],
  [
    '[мин.площадь коттеджа]',
    {
      path: ['villageListSummary', 'cottage', 'minArea'],
      objectType: 'cottage',
      metricType: 'area',
    },
  ],
  [
    '[сред.площадь коттеджа]',
    {
      path: ['villageListSummary', 'cottage', 'avgArea'],
      objectType: 'cottage',
      metricType: 'area',
    },
  ],
  [
    '[макс.площадь коттеджа]',
    {
      path: ['villageListSummary', 'cottage', 'maxArea'],
      objectType: 'cottage',
      metricType: 'area',
    },
  ],
  [
    '[цена_за_м2 коттеджа]',
    {
      path: ['villageListSummary', 'cottage', 'avgPricePerSqm'],
      metricType: 'price',
    },
  ],
  [
    '[найдено участков]',
    {
      path: ['villageListSummary', 'land', 'count'],
      objectType: 'land',
      metricType: 'count',
    },
  ],
  [
    '[мин.цена участка]',
    {
      path: ['villageListSummary', 'land', 'minPrice'],
      metricType: 'price',
    },
  ],
  [
    '[сред.цена участка]',
    {
      path: ['villageListSummary', 'land', 'avgPrice'],
      metricType: 'price',
    },
  ],
  [
    '[макс.цена участка]',
    {
      path: ['villageListSummary', 'land', 'maxPrice'],
      metricType: 'price',
    },
  ],
  [
    '[мин.площадь участка]',
    {
      path: ['villageListSummary', 'land', 'minArea'],
      objectType: 'land',
      metricType: 'area',
    },
  ],
  [
    '[сред.площадь участка]',
    {
      path: ['villageListSummary', 'land', 'avgArea'],
      objectType: 'land',
      metricType: 'area',
    },
  ],
  [
    '[макс.площадь участка]',
    {
      path: ['villageListSummary', 'land', 'avgPricePerAre'],
      objectType: 'land',
      metricType: 'area',
    },
  ],
  [
    '[цена_за_сотку участка]',
    {
      path: ['villageListSummary', 'land', 'maxArea'],
      metricType: 'price',
    },
  ],
  [
    '[признак]',
    {
      path: ['pageData', 'feature'],
      metricType: 'anyString',
    },
  ],
  [
    '[найдено кп]',
    {
      path: ['pageData', 'totalItems'],
      metricType: 'anyNumber',
    },
  ],
  [
    '[N]',
    {
      path: ['pageData', 'totalItems'],
      metricType: 'anyNumber',
    },
  ],
]);
